"use client";

import { Brain, Target, TrendingUp, Users, CheckCircle } from "lucide-react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useState } from "react";

export default function OurMission() {
  const missionAnimation = useScrollAnimation({ delay: 300 });
  const headingAnimation = useScrollAnimation({ delay: 100 });

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-purple-50 to-indigo-100">
      {/* Header */}
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div
          ref={headingAnimation.ref}
          className={`pt-40 pb-16 text-center transition-opacity duration-700 ease-out ${
            headingAnimation.isVisible ? "animate-slide-up" : "opacity-0"
          }`}
        >
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-[#2b2b2b] mb-6">
            Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-purple-800">
              Mission:
            </span>{" "}
            Making Mental Health Support Universal
          </h1>
        </div>
      </div>

      <div
        ref={missionAnimation.ref}
        className={`max-w-3xl text-lg sm:text-xl mx-auto px-6 md:px-12 pb-24 transition-opacity duration-700 ease-out ${
          missionAnimation.isVisible ? "animate-slide-up" : "opacity-0"
        }`}
      >
        <div>
          <p className="text-[#2b2b2b] leading-relaxed mb-6">
            At AnamVR, our mission is to make mental wellbeing universally
            accessible, deeply engaging, and firmly grounded in clinical
            evidence.
          </p>
          <p className="text-[#2b2b2b] leading-relaxed mb-6">
            We exist to solve a global challenge: mental health support is often
            inaccessible, stigmatised, or ineffective. Whether due to long
            waiting lists, high costs, or social stigma, too many people are
            left without the tools they need to manage anxiety, stress, and low
            mood.
          </p>
          <p className="text-[#2b2b2b] leading-relaxed mb-6">
            That’s why we combine therapeutic best practices with emerging
            immersive technology — to offer support that is affordable,
            stigma-free, and designed to meet people where they are: on their
            phones, in their homes, and in the flow of daily life.
          </p>
          <p className="text-[#2b2b2b] leading-relaxed mb-6">
            We don’t just deliver mental health tools. We create immersive,
            emotionally resonant experiences that help people feel better,
            understand themselves more deeply, and return to the world with
            renewed energy and clarity.
          </p>
        </div>
      </div>
    </div>
  );
}
